export default __webpack_public_path__ + "static/media/shokunin_World_Map.494346ce.svg";